import styled, { css } from 'styled-components'

export const Page = styled.div<{ $hideChrome?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hideChrome }) => ($hideChrome ? 0 : '16px')};
`

export const PageTitle = styled.h1<{ $hidden?: boolean }>`
  margin: 0;
  color: #213f68;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;

  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`

/* Mantener children montados: solo ocultar la barra de tabs en vista secundaria */
export const TabsChrome = styled.div<{ $hideChrome?: boolean }>`
  ${({ $hideChrome }) =>
    $hideChrome &&
    css`
      .ant-tabs-bar {
        display: none;
      }

      .ant-tabs-content {
        margin-top: 0;
        border: none;
      }
    `}
`

export const TabDescription = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;
`

export const TabPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const EmptyTabPlaceholder = styled.div`
  min-height: 120px;
`
